var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dialog__buttons" }, [
    _c(
      "button",
      {
        staticClass: "dialog__button dialog__button-cancel",
        on: { click: _vm.closeDialog },
      },
      [_vm._v("\n    Cancel\n  ")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "dialog__button dialog__button-save",
        attrs: { disabled: _vm.disabledOkay },
        on: { click: _vm.clickPositive },
      },
      [_vm._v("\n    " + _vm._s(_vm.textPositive) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }